import { useRef, useState } from 'react';
import { TranslationState, TranslationToggleResult } from './useTranslationToggle.types';

const initState = (personalizedContent: any): TranslationState => ({
    ugcMap: {
        original: { personalizedContent },
        translated: { personalizedContent: { sections: {} } },
    },
    showTranslatedContent: false,
});

const useTranslationToggle = ({ personalizedContent }: { personalizedContent: any }): TranslationToggleResult => {
    const [translationState, setTranslationState] = useState<TranslationState>(initState(personalizedContent));
    const showTranslatedContentRef = useRef(translationState.showTranslatedContent); // used to retrieve the most updated state of translationState.showTranslatedContent

    const onTranslationToggle = ({
        translatedPersonalizedContent,
    }: { translatedPersonalizedContent?: any } = {}): void => {
        setTranslationState((prevTranslationstate) => {
            showTranslatedContentRef.current = !prevTranslationstate.showTranslatedContent;

            return {
                showTranslatedContent: !prevTranslationstate.showTranslatedContent,
                ugcMap: {
                    ...prevTranslationstate.ugcMap,
                    translated: {
                        personalizedContent: {
                            sections: {
                                ...prevTranslationstate.ugcMap.translated?.personalizedContent.sections,
                                ...translatedPersonalizedContent?.personalizedContent.sections,
                            },
                        },
                    },
                },
            };
        });
    };

    return { onTranslationToggle, translationState, setTranslationState, showTranslatedContentRef };
};

export default useTranslationToggle;
